import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SorterService from "../services/sorter";
import { SortKey } from "../types";

type SorterProps = { code: SortKey, onChange: () => void }

export default function Sorter({code, onChange}: SorterProps) {

    const status = SorterService.get(code);

    function toASC() {
        SorterService.set(code, 'ASC');
        if (onChange) {
            onChange();
        }
    }

    function toDESC() {
        SorterService.set(code, 'DESC');
        if (onChange) {
            onChange();
        }
    }

    function toNull() {
        SorterService.set(code, null);
        if (onChange) {
            onChange();
        }
    }

    return (
        <span className="sorter pointer">
            { status === null
                ? <FontAwesomeIcon icon="chevron-down" size="xs" onClick={() => toASC()} />
            : status === 'ASC'
                ? <FontAwesomeIcon icon="chevron-circle-up" size="xs" onClick={() => toDESC()} />
                : <FontAwesomeIcon icon="chevron-circle-down" size="xs" onClick={() => toNull()} />
            }
        </span>
    );
}
